<div style="display: flex; justify-content: flex-end; gap: 8px;">
  <button 
    mat-stroked-button
    (click)="addNewSofRecord()" 
    class="text-muted">
    Add Sof
  </button>

  <button 
    mat-stroked-button
    (click)="addNewSofTemplate()" 
    class="text-muted">
    Add Template
  </button>
</div>
